var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.038 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".no-data_svg__a{fill:#003e5e;fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.524 37.016H2.851a.85.85 0 01-.847-.846V2.847a.85.85 0 01.847-.846h16.185v6.157a2.851 2.851 0 002.851 2.847h6.166v6.5a1 1 0 001 1 1 1 0 001-1v-7.5c0-.381-9.638-10-10.019-10H2.847A2.851 2.851 0 000 2.847v33.325a2.85 2.85 0 002.851 2.845h9.672a1 1 0 001-1 1 1 0 00-.999-1.001zm8.786-28.9V3.544l5.421 5.421h-4.572a.852.852 0 01-.85-.844z",
    className: "no-data_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.046 20.033a9.984 9.984 0 109.992 9.984 9.988 9.988 0 00-9.992-9.984zm0 18a8.018 8.018 0 118.026-8.018 8.022 8.022 0 01-8.026 8.02z",
    className: "no-data_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.821 26.249a.983.983 0 00-1.39 0l-2.386 2.386-2.386-2.386a.983.983 0 00-1.39 1.39l2.386 2.386-2.386 2.386a.983.983 0 001.39 1.39l2.386-2.386 2.386 2.386a.983.983 0 001.39-1.39l-2.386-2.386 2.386-2.386a.983.983 0 000-1.39z",
    className: "no-data_svg__a"
  })));
}

export default SvgNoData;